import { io, Socket } from "socket.io-client"
import { getEndpoint } from "./utils"
import { Env } from "@stencil/core"
// socket-service.ts
export class SocketService {
  //   private static instance: SocketService
  private static instances: Map<string, SocketService> = new Map()
  private socketId: string = ""
  private socket: Socket | null = null
  private mode: string = Env.DATA_MODE

  private constructor(mode: string) {
    this.mode = mode
    this.initSocket()
  }

  //   public static getInstance(mode: string): SocketService {
  //     if (!SocketService.instances.has(mode)) {
  //       SocketService.instances.set(mode, new SocketService(mode))
  //     }
  //     return SocketService.instances.get(mode)!
  //     // return SocketService.instance
  //   }

  private initSocket() {
    if (!this.socket) {
      let a12z_EndPoint = getEndpoint(this.mode)
      // console.log("a12z_EndPoint", a12z_EndPoint)
      this.socket = io(a12z_EndPoint, {
        transports: ["websocket"],
      })

      this.socket.on("connect", () => {
        // console.log("Socket connected", this.socket?.id)
        this.socketId = this.socket?.id
        // Store this instance with its socket ID
        if (this.socketId) {
          // console.log("Socket ID:", this.socketId)
          SocketService.instances.set(this.socketId, this)
        }
      })

      this.socket.on("response", (data: any) => {
        // console.log("Received response:", data)
        window.dispatchEvent(new CustomEvent("streamResponse", { detail: data }))
      })

      this.socket.on("end_response", data => {
        // console.log("Received end_response:", data)
        window.dispatchEvent(new CustomEvent("endResponse", { detail: data }))
      })

      this.socket.on("close", () => {
        // console.log("WebSocket closed. Attempting to reconnect...")
        setTimeout(() => this.initSocket(), 3000) // Reconnect after 3 seconds
      })

      this.socket.on("error", error => {
        console.error("WebSocket error:", error)
      })
      this.socket.on("disconnect", () => {
        // console.log("*********disconnect", this.socket)
        if (this.socketId) {
          SocketService.instances.delete(this.socketId)
        }
      })
    }
  }

  public static createInstance(mode: string): SocketService {
    const instance = new SocketService(mode)
    return instance
  }

  public static getInstanceById(socketId: string): SocketService | undefined {
    return SocketService.instances.get(socketId)
  }

  public getSocket(): Socket | null {
    return this.socket
  }

  public getSocketId(): string {
    return this.socketId
  }

  public disconnect() {
    if (this.socket) {
      this.socket.disconnect()
      this.socket = null
    }
    if (this.socketId) {
      SocketService.instances.delete(this.socketId)
    }
    // console.log("Socket disconnected")
  }

  public static disconnectSocketById(socketId: string) {
    const instance = SocketService.instances.get(socketId)
    if (instance && instance.socket) {
      instance.socket.disconnect()
      SocketService.instances.delete(socketId)
      // console.log(`Socket with ID ${socketId} disconnected`)
    } else {
      console.log(`Socket with ID ${socketId} not found`)
    }
  }
}
